<template>
  <div>
    <ModuleHeader> Creador de Menu digital </ModuleHeader>
    <v-row>
      <v-col>
        <v-autocomplete
          label="Departamentos"
          v-model="departamento"
          item-text="Nombre"
          item-value="id"
          :items="departamentos"
          @input="getMenuGrouper()"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="12" cols="12">
        Agrega elementos para completar el menu visible en la web
      </v-col>
      <v-col md="12" cols="12">
        <v-btn
          @click="showModalAdd({ name: '', baseId: '' })"
          elevation="0"
          color="primary"
          >Agregar nodo padre</v-btn
        >
      </v-col>
      <v-col md="12" cols="12">
        <v-treeview
          v-model="tree"
          :open="initiallyOpen"
          :items="items"
          activatable
          item-key="name"
          open-on-click
        >
          <template v-slot:label="{ item }">
            <div class="v-treeview-node__label">
              {{ item.name }}<br />
              <v-chip class="ma-2" color="success" x-small>
                Orden: {{ item.order }} </v-chip
              ><br />
              <div v-if="item.dataRaw">
                <div
                  v-if="item.dataRaw.cb"
                  class="ml-4"
                  style="font-size:12px;"
                >
                  {{ item.dataRaw.cb }}
                </div>
              </div>
            </div>
          </template>
          <template v-slot:append="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small color="primary" dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="showModalAdd(item)">
                  <v-list-item-title>Agregar nodo</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showModalVincularProductos(item)">
                  <v-list-item-title
                    >Vincular productos al nodo</v-list-item-title
                  >
                </v-list-item>
                <v-list-item @click="showModalEdit(item)">
                  <v-list-item-title>Editar nodo</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteItem(item)">
                  <v-list-item-title>Eliminar nodo</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-treeview>
      </v-col>
    </v-row>
    <modal v-model="addModal" :showFooter="false" title="Agregar Nodo">
      <div v-if="selectedNode">
        Agregando nodo a: {{ selectedNode.name }} || Id:
        {{ selectedNode.baseId }}
      </div>
      <v-text-field
        v-model="identificador"
        label="Clave identificadora"
      ></v-text-field>
      <v-text-field v-model="order" label="Orden"></v-text-field>
      <v-textarea v-model="cb" label="Descripción "></v-textarea>
      <v-btn @click="addItem(selectedNode.baseId)">Agregar nodo</v-btn>
    </modal>
    <modal v-model="editModal" :showFooter="false" title="Editar Nodo">
      <v-text-field
        v-if="selectedNode"
        v-model="selectedNode.ModelName"
        label="Clave identificadora"
      ></v-text-field>
      <v-text-field
        v-if="selectedNode"
        v-model="selectedNode.order"
        label="Orden"
      ></v-text-field>
      <div v-if="selectedNode">
        <v-textarea
          v-if="selectedNode.dataRaw"
          v-model="selectedNode.dataRaw.cb"
          label="Descripción "
        ></v-textarea>
      </div>

      <v-btn @click="editItem()">Editar nodo</v-btn>
    </modal>
    <modal
      v-model="vincularProductosModal"
      :showFooter="false"
      title="Vincular productos al nodo"
    >
      <div v-if="selectedNode">
        Vincular productos al nodo : {{ selectedNode.name }} || Id:
        {{ selectedNode.baseId }}
      </div>
      <v-row>
        <v-col cols="8" md="8">
          <v-autocomplete
            v-model="productoToAdd"
            label="Productos"
            item-text="Nombre"
            item-value="id"
            :items="productos"
          ></v-autocomplete>
        </v-col>
        <v-col cols="4" md="4">
          <v-btn color="green" @click="addProductToNodo(selectedNode.baseId)" dark class="mt-2">Agregar</v-btn>
        </v-col>
        <v-col v-if="selectedNode" cols="12" md="12">
          <div v-if="selectedNode.dataRaw">
            <div v-if="selectedNode.dataRaw.prods">
              <v-list
                subheader
                two-line
              >
                <v-list-item
                  v-for="(prod,index) in selectedNode.dataRaw.prods"
                  :key="index"
                >
                  <v-list-item-content>
                    {{getProdName(index)}}
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn @click="deleteProductFromNodo(selectedNode.baseId,index)" icon>
                      <v-icon color="red lighten-1">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </div>
        </v-col>
        
      </v-row>
    </modal>
  </div>
</template>

<script>
export default {
  name: "TimesCreator",
  components: {},
  props: [],
  data() {
    return {
      departamento: null,
      selectedNode: null,
      addModal: false,
      editModal: false,
      vincularProductosModal: false,
      productoToAdd:null,
      identificador: "",
      cb: "",
      order: 0,
      menuTree: {
        MENU: {
          od: 1,
        },
        "MENU|ENSALADAS": {
          od: 3,
        },
        "MENU|ENTRADAS CALIENTES": {
          od: 1,
        },
        "MENU|ENTRADAS FRIAS": {
          od: 2,
        },
        "MENU|NUESTRO HUMO - ESTILO TEXAS": {
          od: 4,
          cb:
            "Todos nuestros cortes y carnes ahumadas incluyen media porción de una de las siguientes guarniciones:<br>Coleslaw / Puré de papa / Chips de Vegetales / Ensalada Mixta",
          pe:
            "*PRECIO SEGÚN TAMAÑO<br>Productos Importados: Brisket, Pulled Pork, Short Rib, Top Sirloin y Arrachera.",
        },
        "MENU|DEL CARBÓN": {
          od: 5,
          cb:
            "Todos nuestros cortes y carnes ahumadas incluyen media porción de una de las siguientes guarniciones: <br> Coleslaw / Puré de papa / Chips de Vegetales / Ensalada Mixta",
        },
        "MENU|ESPECIALIDADES": {
          od: 6,
        },
        "MENU|TACOS Y SÁNDWICHES": {
          od: 7,
        },
        "MENU|HAMBURGUESAS": {
          od: 8,
        },
        "MENU|GUARNICIONES": {
          od: 9,
        },
        "MENU|POSTRES": {
          od: 10,
        },
        "MENU|MENU PARA NIÑOS": {
          od: 11,
        },
        BEBIDAS: {
          od: 2,
        },
        "BEBIDAS|CAFÉ Y TE": {
          od: 1,
        },
        "BEBIDAS|LOS REFRESCANTES": {
          od: 2,
        },
        "BEBIDAS|LOS REFRESCANTES|FAM COCA": {
          od: 2,
        },
        "BEBIDAS|CERVEZAS": {
          od: 3,
        },
        "BEBIDAS|RON": {
          od: 4,
        },
        "BEBIDAS|WHISKY": {
          od: 5,
        },
        "BEBIDAS|BRANDY": {
          od: 6,
        },
        "BEBIDAS|GINEBRA": {
          od: 7,
        },
        "BEBIDAS|VODKA": {
          od: 8,
        },
        "BEBIDAS|ANIS": {
          od: 9,
        },
        "BEBIDAS|COGNAC": {
          od: 10,
        },
        "BEBIDAS|TEQUILA": {
          od: 11,
        },
        "BEBIDAS|MEZCAL": {
          od: 12,
        },
        "BEBIDAS|APERITIVOS,LICORES Y CREMAS": {
          od: 13,
        },
        "BEBIDAS|COCTELERIA": {
          od: 14,
        },
        VINOS: {
          od: 3,
        },
        "VINOS|COPEO": {
          od: 1,
        },
        "VINOS|BOTELLAS": {
          od: 2,
        },
        "VINOS|BOTELLAS EN PROMOCION": {
          od: 3,
        },
      },
      initiallyOpen: ["public"],
      tree: [],
      items: [
       
      ],
    };
  },
  methods: {
    async getMenuGrouper(){
      let menuTree = await this.$store.getters.getFirebaseApp.database
        .queryBuilder("PDV/CatalogoDigital/"+this.departamento+"/Categorias",
          [
          ]
        )

      if (menuTree.exists()) {
        let result = menuTree.val();
        this.menuTree = result
        this.renderTree();
      } else{
        this.menuTree = {}
        this.renderTree();
      }
    },
    getProdName(id){
      let product =  this.$pgsHelper.getById(this.productos,"id",id)
      if(product){
        return product.Nombre
      }else{
        return "N/A"
      }
    },
    deleteProductFromNodo(baseId,idProd){
      delete this.menuTree[baseId].prods[idProd]
      this.$forceUpdate()
    },
    addProductToNodo(baseId){
      if(this.menuTree[baseId]){
        if(!this.menuTree[baseId].prods){
          this.menuTree[baseId].prods = {}
        }
        this.menuTree[baseId].prods[this.productoToAdd] = true
          
      } 
      this.$forceUpdate()
    },
    showModalAdd(item) {
      this.selectedNode = item;
      this.addModal = true;
    },
    showModalVincularProductos(item) {
      this.selectedNode = item;
      this.vincularProductosModal = true;
    },
    addItem(parent) {
      let parentSufix = "";
      if (parent != "") {
        parentSufix = parent + "|";
      }
      if (!this.menuTree[parentSufix + this.identificador.toUpperCase()]) {
        this.menuTree[parentSufix + this.identificador.toUpperCase()] = {
          od: this.order,
          cb: this.cb,
        };
        this.renderTree();
        this.identificador = "";
        this.order = 0;
        this.cb = "";
      }
      this.addModal = false;
    },
    showModalEdit(item) {
      item.OriginalName = item.name;
      item.ModelName = item.name;
      this.selectedNode = item;
      this.editModal = true;
    },
    editItem() {
      if (this.menuTree[this.selectedNode.baseId.toUpperCase()]) {
        this.menuTree[this.selectedNode.baseId.toUpperCase()] = {
          od: this.selectedNode.order,
          cb: this.selectedNode?.dataRaw?.cb,
        };
        this.editModal = false;
        if (this.selectedNode.OriginalName != this.selectedNode.ModelName) {
          let baseTextToReplace = "";
          let textToReplace = "";
          let textForReplace = "";
          let arrayId = this.selectedNode.baseId.split("|");
          let n = 0;
          let terminar = false;
          while (!terminar) {
            if (arrayId[n] != this.selectedNode.OriginalName) {
              if (n == 0) {
                baseTextToReplace += "" + arrayId[n];
              } else {
                baseTextToReplace += "|" + arrayId[n];
              }
            } else {
              terminar = true;
            }
            n++;
          }
          textToReplace =
            baseTextToReplace + "|" + this.selectedNode.OriginalName;
          textForReplace =
            baseTextToReplace + "|" + this.selectedNode.ModelName;
          this.changeNodeName(textToReplace, textForReplace);
        }
        this.renderTree();
      }
    },
    changeNodeName(from, to) {
      let arrayTree = Object.entries(this.menuTree);
      let newTree = {};
      arrayTree.forEach((item) => {
        item[0] = item[0].replace(from, to);
        newTree[item[0]] = item[1];
      });
      this.menuTree = newTree;
    },
    deleteItem(item) {
      let childs = Object.entries(item.children);
      if (childs.length > 0) {
        this.$swal(
          "El elemento contiene nodos hijos",
          "Elimina los nodos hijos para eliminar el nodo padre",
          "error"
        );
      } else {
        delete this.menuTree[item.baseId];
        this.renderTree();
      }
    },
    dataParseToBaseChilds(indentify) {},
    dataParseToBase(rawData) {
      let baseData = {};
      let dataArray = Object.entries(rawData);
      dataArray.forEach((item) => {
        let identify = item[0].split("|");
        let dataMainParent = null;
        let dataAuxiliarParent = null;
        for (let i = 0; i < identify.length; i++) {
          if (i == 0) {
            if (baseData[identify[i]]) {
              console.log(baseData[identify[i]])
            } else {
              baseData[identify[i]] = {
                id: identify[i],
                baseId: item[0],
                order: item[1].od,
                dataRaw: item[1],
                childs: {},
              };
            }
            dataMainParent = identify[i];
            dataAuxiliarParent = baseData[identify[i]];
          } else {
            //baseData[identify[i]].childs = this.dataParseToBaseChilds(identify[i])
            if (!dataAuxiliarParent.childs[identify[i]]) {
              dataAuxiliarParent.childs[identify[i]] = {
                id: identify[i],
                order: item[1].od,
                baseId: item[0],
                dataRaw: item[1],
                childs: {},
              };
            }
            dataAuxiliarParent = dataAuxiliarParent.childs[identify[i]];
          }
        }
      });
      return baseData;
    },
    dataToTree(data) {
      let dataParsed = [];
      let objetcRoot = Object.entries(data);
      objetcRoot = this.$_.orderBy(objetcRoot, "1.order", "asc");
      objetcRoot.forEach((rootElement) => {
        let order = Number(rootElement[1].order);
        delete rootElement[1].order;
        dataParsed.push({
          name: rootElement[0],
          order: order,
          baseId: rootElement[1].baseId,
          dataRaw: rootElement[1].dataRaw,
          children: this.parseChilds(rootElement[1].childs),
        });
      });
      this.items = dataParsed;
      return dataParsed;
    },
    parseChilds(childsData) {
      let finalChilds = [];
      let childs = Object.entries(childsData);
      childs = this.$_.orderBy(childs, "1.order", "asc");
      childs.forEach((ch) => {
        let order = ch[1]["order"];
        delete ch[1].order;
        finalChilds.push({
          name: ch[0],
          order: order,
          baseId: ch[1].baseId,
          dataRaw: ch[1].dataRaw,
          children: this.parseChilds(ch[1].childs),
        });
      });
      return finalChilds;
    },
    renderTree() {
      let baseData = this.dataParseToBase(this.menuTree);
      let dataTree = this.dataToTree(baseData);
    },
  },
  computed: {
    productos() {
      let prod = this.$store.getters.getProductos;
      let aybProductos = prod.filter(
        (item) => item.Tipo == "AYB-Producto" && !item.Dlat
      );
      return aybProductos;
    },
    departamentos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
  },
  watch: {},
  mounted() {
    //this.dataToTree(this.menuTee);
    //this.renderTree();
  },
  created() {},
};
</script>

<style>
.v-treeview-node__label {
  white-space: normal !important;
}
</style>
